import type { Mode } from '@tabservice/tabfile-client';
import type { Tone } from '@/components/ui/pill';

/** What each e-file mode is called, and the one line that explains it. */
export const modeCopy: Record<Mode, { label: string; hint: string; tone: Tone }> = {
  ats: {
    label: 'IRS test',
    hint: 'E-files go to the IRS test system (ATS). Nothing is filed for real.',
    tone: 'info',
  },
  live: {
    label: 'Live',
    hint: 'E-files are sent to the IRS for real. Verify before submitting.',
    tone: 'warning',
  },
};
